import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { queryKey } from '../hooks/useSearchActiviteitenForEntity'
import { createActiviteitenForEntity } from '../services/createActiviteitenForEntity'

export { useCreateActiviteitenForEntity }

const useCreateActiviteitenForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: createActiviteitenForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKey] })
      successAlert('Activiteiten successvol aangemaakt')
    },
  })
}
